export default "__VITE_ASSET__e99euqOE__"